import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Following } from './Components/Following/Following';
import { RecentActivity } from './Components/Layout/RecentActivity/RecentActivity';
import { CreateNewCollection } from './Pages/CreateNewCollection/CreateNewCollection';
import { CreateNFT } from './Pages/CreateNFT/CreateNFT';
import { Discover } from './Pages/Discover/Discover';
import { Explore } from './Pages/Explore/Explore';
import { Home } from './Pages/Home/Home';
import { OnSale } from './Pages/Profile/OnSale/OnSale';
import { Profile } from './Pages/Profile/Profile';
import { ProfileActivity } from './Pages/Profile/ProfileActivity/ProfileActivity';
import { Settings } from './Pages/Settings/Settings';
import { Items } from './Pages/PublicProfile/Items/Items';
import { PublicProfile } from './Pages/PublicProfile/PublicProfile';
import { UNCSpot } from './Pages/UNCSpot/UNCSpot';
import { UNCSpot2 } from './Pages/UNCSpot2/UNCSpot2';
import { ProfileSettings } from './Pages/Settings/SettingsRoutes/ProfileSettings/ProfileSettings';
import { NotificationSettings } from './Pages/Settings/SettingsRoutes/NotificationsSettings';
import { OffersSettings } from './Pages/Settings/SettingsRoutes/OffersSettings';
import { PaymentSettings } from './Pages/Settings/SettingsRoutes/PaymentSettings';
import { AccountSupportSettings } from './Pages/Settings/SettingsRoutes/AccountSupportSettings';
import { EarningsSettings } from './Pages/Settings/SettingsRoutes/EarningsSettings';
import { MyWatchList } from './Pages/MyWatchList/MyWatchList';
import { MyCollections } from './Pages/MyCollections/MyCollections';
import { CreateCollection } from './Pages/CreateCollection/CreateCollection';
import { ProfileOverview } from './Pages/Profile/ProfileOverview/ProfileOverview';
import { RequestForVerification } from './Pages/RequestForVerification/RequestForVerification';
import { ProfileOwned } from './Pages/Profile/ProfileOwned/ProfileOwned';
import { ProfileCreated } from './Pages/Profile/ProfileCreated/ProfileCreated';
import { ProfilePosts } from './Pages/Profile/ProfilePosts/ProfilePosts';

import { BidDetails } from './Pages/NFTDetails/ExploreNFTDetails/BidDetails';
import { Bids } from './Pages/NFTDetails/ExploreNFTDetails/Bids/Bids';
import { BidOwners } from './Pages/NFTDetails/ExploreNFTDetails/BidOwners/BidOwners';
import { NftDescription } from './Pages/NFTDetails/ExploreNFTDetails/NftDescription/NftDescription';
import { TransactionHistory } from './Pages/NFTDetails/ExploreNFTDetails/TransactionHistory/TransactionHistory';

import { AuctionNFTDetails } from './Pages/NFTDetails/AuctionNFTDetails/AuctionNFTDetails';
import { BuyNFTDetails } from './Pages/NFTDetails/BuyNFTDetails/BuyNFTDetails';
import { MintNFTDetails } from './Pages/NFTDetails/MintNFTDetails/MintNFTDetails';
import { PubProfileActivity } from './Pages/PublicProfile/PubProfileActivity/PubProfileActivity';
import { NftMint } from './Pages/NftMint/NftMint';
import { NftStaking } from './Pages/NftStaking/NftStaking';


const AllRoutes = () => {

    return (
        <Routes>
            <Route path="*" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/discover" element={<Discover />} />
            <Route path="/explore" element={<Explore />} />


            <Route path="/exploreNftDetails/:nftID" element={<BidDetails />} >
                <Route path="bids" element={<Bids />} />
                <Route path="owners" element={<BidOwners />} />
                <Route path="details" element={<NftDescription />} />
                <Route path="history" element={<TransactionHistory />} />
            </Route>

            <Route path="/autionNftDetails/:nftID" element={<AuctionNFTDetails />} >
                <Route path="bids" element={<Bids />} />
                <Route path="owners" element={<BidOwners />} />
                <Route path="details" element={<NftDescription />} />
                <Route path="history" element={<TransactionHistory />} />
            </Route>

            <Route path="/buyNftDetails/:nftID" element={<BuyNFTDetails />} >
                <Route path="owners" element={<BidOwners />} />
                <Route path="details" element={<NftDescription />} />
                <Route path="history" element={<TransactionHistory />} />
            </Route>

            <Route path="/mintNftDetails/:nftID" element={<MintNFTDetails />} >
                <Route path="owners" element={<BidOwners />} />
                <Route path="details" element={<NftDescription />} />
                <Route path="history" element={<TransactionHistory />} />
            </Route>



            <Route path="/publicProfile" element={<PublicProfile />} >
                <Route path="*" element={
                    <h1 className="text-cusBlack dark:text-white mt-6 xs:text-sm pb-28 md:text-2xl">Developer working for this page</h1>
                } />
                <Route path="activity" element={<PubProfileActivity />} />
                <Route path="item" element={<Items />} />
            </Route>

            <Route path="/requestForVerification" element={<RequestForVerification />} />
            <Route path="/createNFT" element={<CreateNFT />} />
            <Route path="/createNewCollection" element={<CreateNewCollection />} />
            <Route path="/nftMint" element={<NftMint />} />
            <Route path="/nftStaking" element={<NftStaking />} />

            <Route path="/uncSpot" element={<UNCSpot />} />
            <Route path="/uncSpot2" element={<UNCSpot2 />} />
            <Route path="/recentActivity" element={<RecentActivity />} />
            {/* <Route path="/uncChat" element={<Messages />} /> */}
            <Route path="/following" element={<Following />} />

            <Route path="/profile" element={<Profile />} >
                <Route path="activity" element={<ProfileActivity />} />
                <Route path="posts" element={<ProfilePosts />} />
                <Route path="onSale" element={<OnSale />} />
                <Route path="owned" element={<ProfileOwned />} />
                <Route path="created" element={<ProfileCreated />} />
                <Route path="overview" element={<ProfileOverview />} />
            </Route>

            <Route path="/settings" element={<Settings />} >

                <Route path="*" element={
                    <h1 className="text-cusBlack dark:text-white mt-6 xs:text-sm pb-28 md:text-4xl">Developer working for this page</h1>
                } />
                <Route path="profile" element={<ProfileSettings />} />
                <Route path="notifications" element={<NotificationSettings />} />
                <Route path="offers" element={<OffersSettings />} />
                <Route path="payment" element={<PaymentSettings />} />
                <Route path="accountSupport" element={<AccountSupportSettings />} />
                <Route path="earnings" element={<EarningsSettings />} />
            </Route>
            <Route path="/myWatchList" element={<MyWatchList />} />

            <Route path="/myCollections" element={<MyCollections />} />
            <Route path="/createCollection" element={<CreateCollection />} />
        </Routes>
    );
};

export default AllRoutes;